import { useEffect, useState } from 'react';
import { Alert, Box, LinearProgress, Sheet, Stack, Typography } from '@mui/joy';
import { APIAdsOversell } from '../../api_ads';
import { formatInt } from './adsConstants';

const STATUS = {
    ok: { color: 'success', text: 'Инвентаря территории хватает' },
    tight: { color: 'warning', text: 'Впритык к пределу территории' },
    oversold: { color: 'danger', text: 'Спрос превышает свободный инвентарь' },
    unknown: { color: 'neutral', text: 'Недостаточно данных по территории' },
};

/**
 * Тип охвата кампании + проверка ёмкости её территории (oversell).
 * Для «всей России» территориальный лимит не применяется.
 */
export default function AdCampaignInsights({ token, campaignId, campaign }) {
    const [ov, setOv] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        setLoading(true);
        APIAdsOversell(token, campaignId)
            .then((r) => { if (alive) setOv(r?.oversell || null); })
            .catch(() => { if (alive) setOv(null); })
            .finally(() => { if (alive) setLoading(false); });
        return () => { alive = false; };
    }, [token, campaignId]);

    const scopeLabel = campaign?.geo_scope_display || campaign?.geo_scope || '—';
    const st = ov ? (STATUS[ov.status] || STATUS.unknown) : null;
    const hasCap = ov && ov.free_per_day !== undefined;

    return (
        <Sheet variant="outlined" sx={{ p: 2, borderRadius: 'md', mb: 2 }}>
            <Typography level="title-sm" sx={{ mb: 1 }}>Охват и ёмкость территории</Typography>
            <Stack direction="row" spacing={2} flexWrap="wrap" sx={{ mb: hasCap ? 1.5 : 0 }}>
                <Box>
                    <Typography level="body-xs" color="neutral">Тип охвата</Typography>
                    <Typography level="body-sm">{scopeLabel}</Typography>
                </Box>
                {ov?.city && (
                    <Box>
                        <Typography level="body-xs" color="neutral">Город</Typography>
                        <Typography level="body-sm">{ov.city}</Typography>
                    </Box>
                )}
                {ov?.region && !ov?.city && (
                    <Box>
                        <Typography level="body-xs" color="neutral">Регион</Typography>
                        <Typography level="body-sm">{ov.region}</Typography>
                    </Box>
                )}
                {ov?.demand !== undefined && (
                    <Box>
                        <Typography level="body-xs" color="neutral">Спрос кампании/сут</Typography>
                        <Typography level="body-sm">{formatInt(ov.demand)} показов</Typography>
                    </Box>
                )}
            </Stack>

            {loading ? (
                <LinearProgress />
            ) : ov ? (
                <>
                    {hasCap && (
                        <Stack direction="row" spacing={2} flexWrap="wrap" sx={{ mb: 1 }}>
                            <Box>
                                <Typography level="body-xs" color="neutral">Свободно/сут</Typography>
                                <Typography level="body-sm">{formatInt(ov.free_per_day)}</Typography>
                            </Box>
                            <Box>
                                <Typography level="body-xs" color="neutral">Заполняемость</Typography>
                                <Typography level="body-sm">{ov.fill_percent}%</Typography>
                            </Box>
                        </Stack>
                    )}
                    <Alert color={st.color} size="sm">
                        {st.text}{ov.message ? ` — ${ov.message}` : ''}
                    </Alert>
                </>
            ) : (
                <Typography level="body-sm" color="neutral">Нет данных по ёмкости.</Typography>
            )}
        </Sheet>
    );
}